import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-blue-900 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22etxqj6b0mv2">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yfcp5gvkz9lo">
        <div className="text-center" data-id="element-22" data-mp="1aogvsfbh86cb">
          <span className="metal-silver inline-flex items-center gap-2 rounded-full border border-slate-400 px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-blue-950" data-id="element-23" data-mp="1apidv3qwtt3j">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="1jh0u1enuw8wm" /> Included at no extra cost
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-25" data-mp="1eoznm9dddcei">
            The {totalBonuses} exclusive bonuses
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="mz4k98sofm6u">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col rounded-xl border border-slate-300/20 bg-blue-950 p-6 shadow-lg shadow-black/20 ${bonus.wide ? 'md:col-span-2' : ''}`} data-id="element-27" data-mp="29q0e0yyyo48k" data-mpi={index}>
                <div className="flex items-center justify-between gap-4" data-id="element-28" data-mp="1vt3g6dkfdmi6">
                  <div className="flex items-center gap-3" data-id="element-29" data-mp="20r569ig9qm35">
                    <span className="metal-silver flex h-10 w-10 items-center justify-center rounded-lg text-blue-950" data-id="element-30" data-mp="20trdti35t1ld">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-31" data-mp="3c6ts26hsdf2d" />
                    </span>
                    <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-slate-300" data-id="element-32" data-mp="3h5elnn2j90hu">
                      Bonus {bonus.number}
                    </p>
                  </div>
                  <p className="text-xs font-bold text-slate-400" data-id="element-33" data-mp="1c4kkepibpoml">
                    <span className="line-through" data-id="element-34" data-mp="1c42boteh5hxs">Real value {bonus.value}</span>
                    <span className="metal-silver ml-2 rounded-md px-2 py-1 text-[11px] font-extrabold uppercase tracking-wide text-blue-950" data-id="element-35" data-mp="1q3jxczwh4f2x">
                      Free
                    </span>
                  </p>
                </div>

                <h3 className="mt-4 text-lg font-extrabold leading-tight text-white" data-id="element-36" data-mp="tdt413zx4xyp">{bonus.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-300" data-id="element-37" data-mp="1757mn9pwyx58">{bonus.description}</p>

                {bonus.items && <ul className="mt-3 grid gap-1.5 sm:grid-cols-2" data-id="element-38" data-mp="12dg5fpsne3rr">
                    {bonus.items.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-slate-200" data-id="element-39" data-mp="endfpgc7h9wb">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-slate-300" aria-hidden="true" data-id="element-40" data-mp="amtkiib70gct" />
                        {item}
                      </li>)}
                  </ul>}

                <div className="flex-1" data-id="element-41" data-mp="5c7iwcujum0p" />
                <p className="mt-4 rounded-lg border-l-4 border-slate-300 bg-white/10 px-4 py-3 text-sm font-semibold text-white" data-id="element-42" data-mp="3mre1gzaodjsg">
                  {bonus.benefit}
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-xl border border-slate-300/30 bg-blue-950/70 px-6 py-6 text-center shadow-lg shadow-black/20 sm:flex-row sm:text-left" data-id="element-43" data-mp="j7t4sb5hkpow">
          <div data-id="element-44" data-mp="9e2k7hchczeh">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-slate-300" data-id="element-45" data-mp="eaj8cbjojdrk">
              Value of all {totalBonuses} bonuses
            </p>
            <p className="mt-1 text-2xl font-extrabold text-slate-400 line-through decoration-red-400 decoration-2" data-id="element-46" data-mp="2u0m8sbstjd9v">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-47" data-mp="3f8ydkl2i3vbx">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-slate-300" data-id="element-48" data-mp="3f9zqyw6zotwt">Your price today</p>
            <p className="metal-silver-text mt-1 text-3xl font-extrabold" data-id="element-49" data-mp="35i3pdb5p2lnu">FREE</p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-bold uppercase tracking-[.14em] text-slate-300" data-id="element-50" data-mp="30jseqy7ks74k">
          Only included in this offer
        </p>
      </div>
    </section>;
}